<template>
  <div
    :class="{
      'game-switcher': true,
      'game-switcher__disabled': disabled
    }"
    v-click-outside="close"
  >
    <div class="game-switcher_item game-switcher_item__header" @click="toggle">
      <div class="game-switcher_inner">
        <img class="game-switcher_value" :src="getPartnerImgUrl(selectedPartner)" :alt="$t(selectedPartnerTitle)" v-if="selectedPartner">
        <span class="game-switcher_value" v-else>{{ $t('Все партнеры') }}</span>
        <span
          v-if="!disabled"
          :class="[{ 'game-switcher_icon__open': show }, 'game-switcher_icon']"
        >
        </span>
      </div>
    </div>
    <Transition name="game-switcher_animate">
      <ul class="game-switcher_dropdown" v-show="show">
        <li
          :class="[{'game-switcher_item__selected': partner === selectedPartner}, 'game-switcher_item']"
          v-for="(title, partner) in partners"
          :key="partner"
          @click="onSelect(partner)"
        >
          <div class="game-switcher_inner">
            <img class="game-switcher_value" :src="getPartnerImgUrl(partner)" :alt="$t(title)">
          </div>
        </li>
      </ul>
    </Transition>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import vClickOutside from 'v-click-outside'

@Component({
  directives: {
    clickOutside: vClickOutside.directive
  }
})
class PartnerSwitcher extends Vue {
  @Prop({ type: String }) selectedPartner
  @Prop({ type: Object }) partners
  @Prop({ type: Boolean }) disabled

  show = false

  get selectedPartnerTitle () {
    return this.partners[this.selectedPartner]
  }

  getPartnerImgUrl (partner) {
    try {
      return require('./img/' + partner + '.png')
    } catch (e) {}
  }

  toggle () {
    if (this.disabled) return
    this.show = !this.show
  }

  close () {
    this.show = false
  }

  onSelect (partner) {
    this.toggle()
    this.$emit('partner-change', partner)
  }
}

export default PartnerSwitcher
</script>

<style lang="scss" src="../GameSwitcher/game-switcher.scss" />
